import { ApolloProvider } from '@apollo/client';
import React from 'react';
import { FunctionComponent } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import { apolloClient } from './apollo-client';
import { Footer } from './components/footer';
import { Header } from './components/header';
import { LoadCSS } from './components/load-css';
import { ResetCss } from './components/reset-css';
import { RootCss } from './components/root-css';
import { ScrollToTop } from './components/scroll-to-top';
import { AdvantagePage } from './pages/advantage-page';
import { BlogListPage } from './pages/blog-list-page';
import { BlogPage } from './pages/blog-page';
import { ContactPage } from './pages/contact-page';
import { GrapeSeedPage } from './pages/grape-seed-page';
import { KidsAmiPage } from './pages/kids-ami-page';
import { KitamiPage } from './pages/kitami-page';
import { KosodatePage } from './pages/kosodate-page';
import { MuronokiPage } from './pages/muronoki-page';
import { NewsListPage } from './pages/news-list-page';
import { NewsPage } from './pages/news-page';
import { RecruitContactPage } from './pages/recruit-contact-page';
import { RecruitPage } from './pages/recruit-page';
import { RecruitPrivacyPolicyPage } from './pages/recruit-privacy-policy-page';
import { RecruitSetumeiEntryPage } from './pages/recruit-setumei-entry-page';
import { StaffPage } from './pages/staff-page';
import { TopPage } from './pages/top-page';

const Outer = styled.div`
  
`

const ContentOuter = styled.div`
`

export const App: FunctionComponent = () => {
  return <ApolloProvider client={apolloClient}>
    <GoogleReCaptchaProvider
      reCaptchaKey="6LdDFsoeAAAAADkyGWyjwCvrPekaV28Mf_DzKt2M"
    >
      <BrowserRouter>
        <ScrollToTop />
        <ResetCss />
        <LoadCSS href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@500;700&display=swap" />
        <RootCss />
        <Outer>
          <Header />
          <ContentOuter>
            <Routes>
              <Route index element={<TopPage />} />
              <Route path="kitami" element={<KitamiPage />} />
              <Route path="muronoki" element={<MuronokiPage />} />
              <Route path="kids-ami" element={<KidsAmiPage />} />
              <Route path="grape-seed" element={<GrapeSeedPage />} />
              <Route path="kosodate" element={<KosodatePage />} />
              <Route path="staff" element={<StaffPage />} />
              <Route path="advantage" element={<AdvantagePage />} />
              <Route path="recruit" element={<RecruitPage />} />
              <Route path="news" element={<NewsListPage />} />
              <Route path="news/:newsId" element={<NewsPage />} />
              <Route path="blog" element={<BlogListPage />} />
              <Route path="blog/:blogId" element={<BlogPage />} />
              <Route path="contact" element={<ContactPage />} />
              <Route path="recruit" element={<RecruitPage />} />
              <Route path="recruit/privacy-policy" element={<RecruitPrivacyPolicyPage />} />
              <Route path="recruit/setumei-entry" element={<RecruitSetumeiEntryPage />} />
              <Route path="recruit/contact" element={<RecruitContactPage />} />
            </Routes>
          </ContentOuter>
          <Footer />
        </Outer>
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  </ApolloProvider>
}